import _ from 'lodash';
import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export function fetchHazmatClasses() {
  const url = ApiUrl('v2/hazard_class');

  return Call(
    'get',
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { hazmat_classes: 'hazmat_classes_data' } }
  );
}

export function fetchUNNumbers(formData) {
  const url = ApiUrl(`v2/organization_hazmat_classes?organization_id=${formData.organization_id}`);

  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    { responseDataKeys: { un_numbers: "hazmat_materials" } }
  );
}